module.exports = __webpack_public_path__ + "static/media/user.c05f2fa3.svg";